import { lazy } from "react";

const Apps = lazy(() => import("./Apps"));
const FindApps = lazy(() => import("./FindApps"));

const AppsRoutes = [
  {
    path: "/apps/overview",
    element: <Apps />,
  },
  {
    path: "/apps/findapps",
    element: <FindApps />,
  },
  
 
];

export default AppsRoutes;
